// components/common/SymbolLogo.tsx (예시)

import Image from "next/image";
import React from "react";
const LOGO_SRC = "/assets/images/logo/symbol.svg";
const LOGO_ALT = "Symbol Logo";

// 컴포넌트 Props 타입 정
interface SymbolLogoProps {
  size: number;
  /** 추가적인 Tailwind CSS 클래스 */
  className?: string;
}

export function SymbolLogo({ size, className }: SymbolLogoProps) {
  const sizeValue = Math.max(1, size); // 최소 크기 1px

  return (
    <Image
      src={LOGO_SRC}
      alt={LOGO_ALT}
      width={sizeValue}
      height={sizeValue}
      className={className}
    />
  );
}
